const PRODUCT_GROUP = {
  PSC: "PSC",
  PDFAI: "PDFAI",
  FRX: "FRX",
  TKC: "TKC",
  NSTST: "NSTST",
  TST: "TST",
  APAUTO: "APAUTO",
}

export default {
  namespaced: true,
  state: {
    open: true,
    company: "",
    item: 1,
    itemsTKC: [
      {
        icon: "icon_invoice.svg",
        icon_active: "icon_invoice_white.svg",
        text: "เอกสารใบแจ้งหนี้",
        link: "Company.DocumentTOPSERV",
        group: PRODUCT_GROUP.TKC,
      },
    ],
    itemsExchangeRate: [
      {
        icon: "icon_money_exchange.svg",
        icon_active: "icon_money_exchange_white.svg",
        text: "อัตราแลกเปลี่ยน",
        link: "Company.ExchangeRate",
        group: PRODUCT_GROUP.FRX,
      },
      {
        icon: "icon_exchange_file.svg",
        icon_active: "icon_exchange_file_white.svg",
        text: "ประวัติอัตราแลกเปลี่ยน",
        link: "Company.ExchangeHistory",
        group: PRODUCT_GROUP.FRX,
      },
    ],
    itemsNsThaiSmartTax: [
       ///ภาษีมูลค่าเพี่ม
       {
        icon: "icon_menu_withholding.svg",
        icon_active: "icon_menu_withholding_active_white.svg",
        text: "ภาษีมูลค่าเพี่ม",
        link: "Company.ReportThaiTax",
        group: PRODUCT_GROUP.TST,
      },
      {
        text: "ภาษีขาย",
        link: "Company.TaxSales",
        group: PRODUCT_GROUP.TST,
      },
      {
        text: "ภาษีชื้อ",
        link: "Company.TaxBuy",
        group: PRODUCT_GROUP.TST,
      },
      {
        text: "รายงานภาษีมูลค่าเพิ่ม",
        link: "Company.taxSupplementaryReport",
        group: PRODUCT_GROUP.TST,
      },
      {
        text: "แบบแสดงรายการภาษี",
        link: "Company.TaxReport",
        group: PRODUCT_GROUP.TST,
      },
      {
        text: "ยกเลิกรายการ Vat",
        link: "Company.CancelValueAddedTax",
        group: PRODUCT_GROUP.TST,
      },
      {
        icon: "icon_menu_withholding.svg",
        icon_active: "icon_menu_withholding_active_white.svg",
        text: "ภาษีหัก ณ ที่จ่าย",
        link: "Company.ReportNetsuiteThaiTax",
        group: PRODUCT_GROUP.NSTST,
      },
      {
        text: "ภาษีหัก ณ ที่จ่าย",
        link: "Company.WithholdingTax",
        group: PRODUCT_GROUP.NSTST,
      },
      {
        text: "แบบยื่นรายการภาษี",
        link: "Company.WithholdingIncomTax",
        group: PRODUCT_GROUP.NSTST,
      },
      {
        text: "ยกเลิกรายการ WHT",
        link: "Company.WithholdingIncomTax.Cancel",
        group: PRODUCT_GROUP.NSTST,
      },
    ],
    itemsApAutomate: [
      {
        icon: "icon_menu_ap.svg",
        icon_active: "icon_menu_ap_white.svg",
        text: "AP Automate",
        link: "Company.AccountsPayable",
        group: PRODUCT_GROUP.APAUTO,
      },
      {
        icon: "icon_menu_ap_report.svg",
        icon_active: "icon_menu_ap_report_white.svg",
        text: "AP Analytics",
        link: "Company.AccountsPayableAnalytics",
        group: PRODUCT_GROUP.APAUTO,
        onlydev: true 
      },
      {
        icon: "icon_ap_tax_report.svg",
        icon_active: "icon_ap_tax_report_white.svg",
        text: "AP Tax Report",
        link: "Company.AccountsPayableTaxReport",
        group: PRODUCT_GROUP.APAUTO,
      }
    ],
    itemsSetting:   {
      icon: "icon_menu_setting.svg",
      icon_active: "icon_menu_setting_active_white.svg",
      text: "ตั้งค่า",
      link: "Company.Settings",
    },
    itemLoading: true,
    itemsPSC: [
        {
        icon: "icon_menu_dashboard.svg",
        icon_active: "icon_menu_dashboard_active_white.svg",
        text: "หน้าสรุป",
        link: "Company.Dashboard",
        group: PRODUCT_GROUP.PSC,
      },
      {
        icon: "icon_menu_ecommerce.svg",
        icon_active: "icon_menu_tax_active_white.svg",
        text: "ใบสั่งขายออนไลน์",
        link: "Company.DocumentsSaleOnline",
        subLinks: [],
        group: PRODUCT_GROUP.PSC,
      },
      {
        icon: "icon_menu_tax.svg",
        icon_active: "icon_menu_tax_active_white.svg",
        text: "เอกสารการขาย",
        link: "Company.Documents",
        subLinks: [],
        group: PRODUCT_GROUP.PSC,
      },
      {
        text: "ใบกำกับภาษีเต็มรูป",
        link: "Company.Documents.TX",
        group: PRODUCT_GROUP.PSC,
      },
      {
        text: "ใบเพิ่มหนี้",
        link: "Company.Documents.DR",
        group: PRODUCT_GROUP.PSC,
      },
      {
        text: "ใบลดหนี้",
        link: "Company.Documents.CR",
        group: PRODUCT_GROUP.PSC,
      },
      {
        text: "ใบรับ",
        link: "Company.Documents.RE",
        group: PRODUCT_GROUP.PSC,
      },
      {
        text: "ใบกำกับภาษีอย่างย่อ",
        link: "Company.Documents.AB",
        group: PRODUCT_GROUP.PSC,
      },
      {
        text: "ใบเสร็จรับเงิน/ใบกำกับภาษี",
        link: "Company.Documents.RT",
        group: PRODUCT_GROUP.PSC,
      },
      {
        text: "ใบแจ้งยกเลิก",
        link: "Company.Documents.CL",
        group: PRODUCT_GROUP.PSC,
      },
      {
        icon: "icon_menu_purchase_order.svg",
        icon_active: "icon_menu_tax_active_white.svg",
        text: "เอกสารการซื้อ",
        link: "Company.DocumentsPurchase",
        subLinks: [],
        group: PRODUCT_GROUP.PSC,
      },
      {
        icon: "icon_menu_report.svg",
        icon_active: "icon_menu_report_active_white.svg",
        text: "รายงาน",
        link: "Company.Report",
        group: PRODUCT_GROUP.PSC,
      },
    ],
    itemsVendor: [
          {
        icon: "icon_menu_dashboard.svg",
        icon_active: "icon_menu_dashboard_active_white.svg",
        text: "Report PO / SO",
        link: "Company.reportDocumentAI",
        group: PRODUCT_GROUP.PDFAI,
      },
      {
        icon: "icon_menu_poai.svg",
        icon_active: "icon_menu_poai_white.svg",
        text: "Customer PO",
        link: "Company.DocumentPOAI",
        group: PRODUCT_GROUP.PDFAI,
      },
      {
        link: "Company.DocumentSOAI",
        icon: "icon_menu_soai.svg",
        icon_active: "icon_menu_soai_white.svg",
        text: "Sale Order",
        group: PRODUCT_GROUP.PDFAI
      },
    ],
    vendorPOList: [
    ],
    vendorSOList: [
    ],
    isItemLoading: true,
    vendorListMerged: false,
    profileMenuToggle: false,
  },
  mutations: {
    setDrawer(state) {
      state.open = !state.open;
    },
    setProfileMenu(state) {
      state.profileMenuToggle = !state.profileMenuToggle;
    },
    setVendorPOList(state, newValue) {
      // Check if newValue is an object or an array (assuming vendorPOList expects an object or array)
      if (Array.isArray(newValue)) {
        state.vendorPOList = newValue;
      } else {
        console.error("Invalid newValue type. Expected array.");
      }
    },
    setVendorSOList(state, newValue) {
      // Check if newValue is an object or an array (assuming vendorPOList expects an object or array)
      if (Array.isArray(newValue)) {
        state.vendorSOList = newValue;
      } else {
        console.error("Invalid newValue type. Expected array.");
      }
    },
    mergeVendorList(state) {
      // Remove any existing vendor lists to avoid duplicates
      state.itemsVendor = state.itemsVendor.filter(item => item.link !== "Company.DocumentPOAIVendor" && item.link !== "Company.DocumentSOAIVendor");

      const documentPOAIIndex = state.itemsVendor.findIndex(item => item.link === "Company.DocumentPOAI");

      // Insert vendorPOList after the second to last item if POAI is found
      if (documentPOAIIndex !== -1) {
        const insertionIndexPO = state.itemsVendor.length - 1;
        state.itemsVendor.splice(insertionIndexPO, 0, ...state.vendorPOList);
      }

      // Recalculate documentSOAIIndex since the array might have changed
      const newDocumentSOAIIndex = state.itemsVendor.findIndex(item => item.link === "Company.DocumentSOAI");

      // Insert vendorSOList after the new documentSOAIIndex
      if (newDocumentSOAIIndex !== -1) {
        const insertionIndexSO = newDocumentSOAIIndex + 1;
        state.itemsVendor.splice(insertionIndexSO, 0, ...state.vendorSOList);
      }
      state.isItemLoading = false;
    },
    setVendorListMerged(state) {
      state.vendorListMerged = true; // Set the flag to true
    },
    setIsItemLoading(state, payload) {
      state.isItemLoading = payload.newValue;
    },
    setitemsTKC(state, newValue) {
      if (Array.isArray(newValue)) {
        state.itemsTKC = [state.itemsTKC[0], ...newValue];
      }
    }
  },
  actions: {
    toggle({ commit }) {
      commit("setDrawer");
    },
    toggleProfileMenu({ commit }) {
      commit("setProfileMenu");
    },
    setIsItemLoading({ commit }, payload) {
      console.log("Hello from setIsItemLoading action", payload)
      commit("setIsItemLoading", payload);
    },
  },
  modules: {}
};
